export default "__VITE_ASSET__mBx8O3S4__"